export const SMART_CARD_ORDER_BY_SORT_ASC = { direction: "asc" as const, nulls: "last" as const };

export const SMART_CARD_ORDER_BY_CREATED_ASC = {
  direction: "asc" as const,
  nulls: "last" as const,
};

export const SMART_VIEW_ORDER_BY_OPTIONS = { direction: "desc" as const, nulls: "last" as const };
